/* global APP */
import { connect } from 'react-redux';
import { translate } from '../../../../base/i18n/functions';
import { toggleDialog } from '../../../../moderator-controller/slice';
import AbstractSecurityDialogButton, { _mapStateToProps as _abstractMapStateToProps } from '../AbstractSecurityDialogButton';
import { closeOverflowMenuIfOpen } from '../../../../toolbox/actions.web';
/**
 * Implements an {@link AbstractSecurityDialogButton} to open the security dialog.
 */
class SecurityDialogButton extends AbstractSecurityDialogButton {
    /**
     * Opens / closes the security dialog.
     *
     * @private
     * @returns {void}
     */
    _handleClickSecurityButton() {
        const { dispatch } = this.props;
        dispatch(closeOverflowMenuIfOpen());
        APP.store.dispatch(toggleDialog());
    }
}
export default translate(connect(_abstractMapStateToProps)(SecurityDialogButton));
